module.exports = __webpack_public_path__ + "media/stockholm/ship_pic-8663d4a4.jpg";